import { NbToastrConfig, NbGlobalLogicalPosition } from '@nebular/theme';

export const toastrConf: Partial<NbToastrConfig> = {
  duration: 5000,
  icon: '',
  position: NbGlobalLogicalPosition.BOTTOM_END
};
